var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "birthday_nomination_form",
      class: { _thankyou: _vm.thankyou },
      attrs: {
        method: "post",
        action:
          "https://australia-southeast1-foxtware.cloudfunctions.net/apexShopifyCustomerInfoUpdate",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "bday_nom_inner" }, [
        _c("h2", { staticClass: "account_title" }, [
          _vm._v("Is it your bday?"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "It looks like we don't know your birthday! Enter it here so we can celebrate with you:"
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "birthday_nomination_form_submit_wrapper" },
          [
            _c("birth-date-field", {
              ref: "field",
              attrs: {
                name: "birth_date",
                max: _vm.max,
                "data-mask": _vm.bday_format,
                "data-autofill-chars": "/-",
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit", disabled: _vm.busy },
                domProps: { innerHTML: _vm._s(_vm.buttonHtml) },
                on: { click: _vm.submitAttempted },
              },
              [_vm._v("Update")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bday_nom_thankyou_message" }, [
      _vm._v("\n      Thanks babe! \n      "),
      _c("p", [
        _vm._v(
          "Did you know that Loyalty Club members Level 1+ get a discount on their birthday? If that's you, keep an eye out!"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }